import { render, staticRenderFns } from "./AddSigners.vue?vue&type=template&id=7996e3dc&"
import script from "./AddSigners.vue?vue&type=script&lang=js&"
export * from "./AddSigners.vue?vue&type=script&lang=js&"
import style0 from "./AddSigners.vue?vue&type=style&index=0&id=7996e3dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports